import React from "react";

import { SingleMovieProvider } from "./context/SingleMovieProvider";
import { MovieAssetsList } from "./MovieAssetsList";

export const MovieAssetsListDashboard: React.FC = () => {
    return (
        <SingleMovieProvider>
            <MovieAssetsList />
        </SingleMovieProvider>
    );
};
